import React, { Fragment } from 'react';
import { Router } from '@reach/router';
import PrivateInvoicePortalRoute from '../../../components/invoice-payment-portal/routing/PrivateInstallerRoute';
import InvoiceList from '../../../components/invoice-payment-portal/invoice-list';
import InvoicePaymentRouter from '../../../components/invoice-payment-portal/protected-pages/InvoicePaymentRouter';
import InvoicePaymentConfirmation from '../../../components/invoice-payment-portal/protected-pages/invoice-payment-confirmation';
import Profile from '../../../components/invoice-payment-portal/profile';

const SecureRouter = () => {
  return (
    <Fragment>
      <Router basepath='/invoice-payment/secure/'>
        <PrivateInvoicePortalRoute
          path='/invoices/'
          component={InvoiceList}
        />
        <PrivateInvoicePortalRoute
          path='/*' // This will catch all routes under /invoices, including :invoiceId/*
          component={InvoicePaymentRouter}
        />
        <PrivateInvoicePortalRoute
          path={'/invoices/:invoiceId/payment-confirmation'} // This will catch all routes under /invoices, including :invoiceId/*
          component={InvoicePaymentConfirmation}
        />    
        <PrivateInvoicePortalRoute
          path={'/profile/*'}
          component={Profile}
        />    
      </Router>
    </Fragment>
  );
};
export default SecureRouter;
